<div class="test-mode">
  <div class="card">
    <div class="upper">
      <div class="header">
        <pdq-heading element="h3">Test mode</pdq-heading>
        <form [formGroup]="formGroup">
          <pdq-slide-toggle formControlName="isTestMode" [defaultValue]="settings?.isTestMode"></pdq-slide-toggle>
        </form>
      </div>
      <pdq-heading element="h6">Preview this checkout method on your live store (hidden from customers).</pdq-heading>
    </div>
    <div class="down">
      <pdq-heading element="h6">To test, enter “PDQ” in Address Line 2 at checkout.</pdq-heading>
    </div>
  </div>
</div>
